module.exports = __webpack_public_path__ + "img/icon-delete-variant.3cb509a9.svg";